import { getBackwardsCompatibleNumberFormat } from "./getBackwardsCompatibleNumberFormat";
/**
 * Util function to get formatted currency amount
 *
 * @param locale
 * @param currency ISO Currency Code
 * @param amount Given in cents when applicable
 * @param showDecimals
 */
export const getFormattedCurrencyAmount = (locale, currency, amount, showDecimals = false) => {
    let options = null;
    // if the amount includes cents (amount % 100 !== 0) and we want to show decimals,
    // then show exactly 2 fraction digits
    if (amount % 100 !== 0 && showDecimals) {
        options = {
            style: "currency",
            currencyDisplay: "narrowSymbol",
            currency: currency || "eur",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        };
    }
    else {
        options = {
            style: "currency",
            currencyDisplay: "narrowSymbol",
            currency: currency || "eur",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        };
    }
    const numberFormat = getBackwardsCompatibleNumberFormat(locale || "en", options);
    const parts = numberFormat.formatToParts(amount / 100);
    const currencyCode = currency.toUpperCase().slice(0, -1);
    let formatedCurrencyAmount = "";
    if (currencyCode === "EU" || currencyCode === "GB")
        return numberFormat.format(amount / 100);
    else {
        for (const part of parts) {
            if (part.type === "currency") {
                formatedCurrencyAmount += `${currencyCode} ${part.value}`; // If the part is the currency symbol, add currencyCode in front
            }
            else {
                formatedCurrencyAmount += part.value;
            }
        }
        return formatedCurrencyAmount;
    }
};
